import { gql } from "@apollo/client";
import { DspType } from "graphql/types/DspType";
import { client } from "graphql/client";

export const GET_DSP_BY_ID = gql`
    query GetDspById($id: Long!) {
        getDspById(id: $id) {
            id
            name
            dspCode
        }
    }
`;

export interface GetDspByIdQueryVariables {
    id: number;
}

export interface GetDspByIdQuery {
    getDspById: DspType;
}

export const getDspById = async (id: number): Promise<DspType> => {
    const { data } = await client.query<GetDspByIdQuery, GetDspByIdQueryVariables>({
        query: GET_DSP_BY_ID,
        variables: { id }
    });
    return data.getDspById;
}